// import React, { useRef } from 'react';
// import { Box, TextField, InputAdornment, IconButton, Tooltip } from '@mui/material';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
//
// const UploadField = ({ label, placeholder, onFileSelect }) => {
// 	const fileInputRef = useRef(null);
//
// 	const handleClick = () => {
// 		fileInputRef.current?.click();
// 	};
//
// 	const handleChange = (event) => {
// 		if (event.target.files.length > 0) {
// 			onFileSelect(event.target.files[0]);
// 		}
// 	};
//
// 	return (
// 		<Box>
// 			<input
// 				type="file"
// 				accept="image/*"
// 				ref={fileInputRef}
// 				style={{ display: 'none' }}
// 				onChange={handleChange}
// 			/>
// 			<TextField
// 				fullWidth
// 				margin="normal"
// 				label={label}
// 				value=""
// 				placeholder={placeholder}
// 				onClick={handleClick}
// 				InputProps={{
// 					readOnly: true,
// 					endAdornment: (
// 						<InputAdornment position="end">
// 							<Tooltip title="Upload a photo">
// 								<IconButton onClick={handleClick}>
// 									<CloudUploadIcon />
// 								</IconButton>
// 							</Tooltip>
// 						</InputAdornment>
// 					),
// 				}}
// 			/>
// 		</Box>
// 	);
// }
//
// export default UploadField;


import React, { useRef } from 'react';
import { Box, TextField, InputAdornment, IconButton, Tooltip } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const UploadField = ({ label, placeholder, onFileSelect }) => {
	const fileInputRef = useRef(null);

	const handleClick = () => {
		fileInputRef.current?.click();
	};

	const handleChange = (event) => {
		if (event.target.files.length > 0) {
			onFileSelect(event.target.files[0]);
		}
	};

	return (
		<Box>
			<input
				type="file"
				accept="image/*"
				ref={fileInputRef}
				style={{ display: 'none' }}
				onChange={handleChange}
			/>
			<TextField
				fullWidth
				margin="normal"
				label={label}
				value=""
				placeholder={placeholder}
				onClick={(e) => {
					e.stopPropagation(); // מונע bubbling
					handleClick();
				}}
				InputProps={{
					readOnly: true,
					endAdornment: (
						<InputAdornment position="end">
							<Tooltip title="Upload a photo">
								<IconButton
									onClick={(e) => {
										e.stopPropagation(); // גם כאן מונע כפילות
										handleClick();
									}}
								>
									<CloudUploadIcon />
								</IconButton>
							</Tooltip>
						</InputAdornment>
					),
				}}
			/>

		</Box>
	);
}

export default UploadField;
